import { combineReducers } from "redux";
import UserActivation from "./auth/user-activation.reducers";
import ForgotPassword from "./auth/forgot-password.reducers";
const rootReducer = combineReducers({
    UserActivation,
    ForgotPassword
});

export default rootReducer;